import { Component, Inject } from '@angular/core';
import { ISitemap, SITEMAP } from 'pbc.angular';
import { IFilterConfig, ISelection } from 'pbc.types';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { DashboardQueryFilterConfig, IDashboardResponse } from 'fa-kt.types';

import { DashboardService } from '../service';

@Component({
  selector: 'fa-kt-dashboard-filter',
  templateUrl: './dashboard-filter.component.html',
  styleUrls: ['./dashboard-filter.component.css'],
})
export class DashboardFilterComponent {
  readonly subscriptions: Subscription[] = [];

  public DashboardFilterConfig: IFilterConfig<IDashboardResponse>;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public dashboard: DashboardService,
  ) {
    this.DashboardFilterConfig = DashboardQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.DashboardFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.DashboardFilterConfig[index].selections = shapes;
  }
}
